import axios from "./interceptor";
import { BASE_URL } from "../constant";
import {
  SHOW_SUCCESS,
  FETCH_MANUFACTURER_CODE_SUCCESS,
  FETCH_MANUFACTURER_CODE_FAILURE,
  MANUFACTURER_CODE_FILTER,
  SORT_MANUFACTURER_CODE_LIST,
  MANUFACTURER_CODE_CLEAR_FILTER,
} from "./types";
import { handleError } from "../utils/utils";

export const createManufacturerCode =
  (manufacturerCode) => async (dispatch) => {
    const requestDto = {
      manufacturerCode: manufacturerCode,
      active: true,
    };
    console.log("Posting " + JSON.stringify(requestDto));

    return axios
      .post(`${BASE_URL}/current/article/upsertManufacturerCode`, requestDto)
      .then((response) => {
        dispatch({
          type: SHOW_SUCCESS,
          payload: {
            message: "messages.manufacturerCode.createSuccessful",
            dialogType: "success",
          },
        });
        return response;
      })
      .catch((error) => {
        handleError(error, dispatch);
        throw error;
      });
  };

export const deleteManufacturerCode =
  (manufacturerCode) => async (dispatch) => {
    const requestDto = {
      manufacturerCode: manufacturerCode,
      active: false,
    };
    console.log("Posting " + JSON.stringify(requestDto));

    return axios
      .post(`${BASE_URL}/current/article/upsertManufacturerCode`, requestDto)
      .then((response) => {
        dispatch({
          type: SHOW_SUCCESS,
          payload: {
            message: "messages.manufacturerCode.deleteSuccessful",
            dialogType: "success",
          },
        });
        return response;
      })
      .catch((error) => {
        handleError(error, dispatch);
        throw error;
      });
  };

export const fetchManufacturerCodeList = (path) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/current/article/getManufacturerCodes?${path}`
    );
    dispatch({ type: FETCH_MANUFACTURER_CODE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_MANUFACTURER_CODE_FAILURE, payload: error });
  }
};

export const updateFiltersForManufacturerCodeList = (filterKey, filterValue) => {
  return {
    type: MANUFACTURER_CODE_FILTER,
    payload: {
      filterKey,
      filterValue
    },
  };
};

export const sortManufacturerCodeList = (orderBy, sort) => {
  return {
    type: SORT_MANUFACTURER_CODE_LIST,
    payload: { orderBy, sort },
  };
};

export const clearManufacturerCodeFilters = () => {
  return {
    type: MANUFACTURER_CODE_CLEAR_FILTER,
  };
};
